import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
//librerias
import { ChartModule } from 'angular-highcharts';
import * as Highcharts from 'highcharts/highcharts';
import HighchartsMore from 'highcharts/highcharts-more.src';
import HighchartsSolidGauge from 'highcharts/modules/solid-gauge';

HighchartsMore(Highcharts);
HighchartsSolidGauge(Highcharts);

import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
// componentes
import { HeaderComponent } from './plantilla/header/header.component';
import { MenuComponent } from './plantilla/menu/menu.component';
import { FooterComponent } from './plantilla/footer/footer.component';
import { LfsaInputComponent } from './components/lfsa-input/lfsa-input.component';
import { LfsaErrorMsgComponent } from './components/lfsa-error-msg/lfsa-error-msg.component';
import { LfsaBotonEditarGridComponent } from './components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { LfsaCardComponent } from './components/lfsa-card/lfsa-card.component';
import { LfsaComboBoxComponent } from './components/lfsa-combo-box/lfsa-combo-box.component';
import { LfsaModalComponent } from './components/lfsa-modal/lfsa-modal.component';
import { LfsaBotonesFormularioComponent } from './components/lfsa-botones-formulario/lfsa-botones-formulario.component';
import { LfsaCardV2Component } from './components/lfsa-card-v2/lfsa-card-v2.component';
import { LfsaLoadingV2Component } from './components/lfsa-loading-v2/lfsa-loading-v2.component';
import { LfsaLoadingComponent } from './components/lfsa-loading/lfsa-loading.component';
import { LfsaOptionsComponent } from './components/lfsa-options/lfsa-options.component';
import { LfsaOptionsExportComponent } from './components/lfsa-options-export/lfsa-options-export.component';
import { LfsaGhBarraSimpleComponent } from './components/graficos-high-chart/lfsa-gh-barra-simple/lfsa-gh-barra-simple.component';
import { LfsaGhColumnSimpleComponent } from './components/graficos-high-chart/lfsa-gh-column-simple/lfsa-gh-column-simple.component';
import { LfsaGhParetoComponent } from './components/graficos-high-chart/lfsa-gh-pareto/lfsa-gh-pareto.component';
import { LfsaGhPastelComponent } from './components/graficos-high-chart/lfsa-gh-pastel/lfsa-gh-pastel.component';
import { LfsaGhStackbarComponent } from './components/graficos-high-chart/lfsa-gh-stackbar/lfsa-gh-stackbar.component';
import { LfsaComboBoxMultComponent } from './components/lfsa-combo-box-mult/lfsa-combo-box-mult.component';
import { LfsaInputSearchComponent } from './components/lfsa-input-search/lfsa-input-search.component';
import { AgGridModule } from 'ag-grid-angular';
import { LfsaButtonLoadingComponent } from './components/lfsa-button-loading/lfsa-button-loading.component';
import { ManuV2Component } from './plantilla/manu-v2/manu-v2.component';
import { LfsaDtTablaComponent } from './components/lfsa-dt-tabla/lfsa-dt-tabla.component';
import { LfsaBotonsGridComponent } from './components/lfsa-botons-grid/lfsa-botons-grid.component';
import { LfsaAlertsComponent } from './components/lfsa-alerts/lfsa-alerts.component';
import { TooltipModule } from 'ng2-tooltip-directive';
import { LfsaOptionExportPortalComprasComponent } from './components/lfsa-option-export-portal-compras/lfsa-option-export-portal-compras.component';
import { NumericAggridComponent } from './components/numeric-aggrid/numeric-aggrid.component';
import { LfsaGhGaugeComponent } from './components/graficos-high-chart/lfsa-gh-gauge/lfsa-gh-gauge.component';
import { LfsaGhDualAxesComponent } from './components/graficos-high-chart/lfsa-gh-dual-axes/lfsa-gh-dual-axes.component';
import { LfsaComboBoxV3Component } from './components/lfsa-combo-box-v3/lfsa-combo-box-v3.component';
import {FormControlPipe} from "./pipes/abstractControlToFormControl.pipe";
import {CheckboxRenderer} from "./components/lfsa-checkbox/lfsa-checkbox.component";
import { LfsaPageSizeSelectorComponent } from './components/lfsa-page-size-selector/lfsa-page-size-selector.component';
import { LfsaSwitchComponent } from './components/lfsa-switch/lfsa-switch.component';
import { LfsaDivRespuestaSapComponent } from './components/lfsa-div-respuesta-sap/lfsa-div-respuesta-sap.component';
import { LfsaSelectOptIspComponent } from './components/lfsa-select-opt-isp/lfsa-select-opt-isp.component';
import {NgSelectModule} from "@ng-select/ng-select";
import { LfsaGhCampanaGaussComponent } from './components/graficos-high-chart/lfsa-gh-campana-gauss/lfsa-gh-campana-gauss.component';
import { LfsaAccordionIspComponent } from './components/lfsa-accordion-isp/lfsa-accordion-isp.component';
import { LfsaSwitchIspComponent } from './components/lfsa-switch-isp/lfsa-switch-isp.component';
import { LfsaSearchListIspComponent } from './components/lfsa-search-list-isp/lfsa-search-list-isp.component';
import {NgxDatatableModule} from "@swimlane/ngx-datatable";
import { LfsaGhAreaComponent } from './components/graficos-high-chart/lfsa-gh-area/lfsa-gh-area.component';
import { BusquedaClienteModule } from './components/busqueda-cliente/busqueda-cliente.module';
import { ChatbotWidgetComponent } from './components/chatbot-widget/chatbot-widget.component';

@NgModule({
  declarations: [
    HeaderComponent,
    MenuComponent,
    FooterComponent,
    LfsaInputComponent,
    LfsaErrorMsgComponent,
    LfsaBotonEditarGridComponent,
    LfsaCardComponent,
    LfsaComboBoxComponent,
    LfsaModalComponent,
    LfsaBotonesFormularioComponent,
    LfsaCardV2Component,
    LfsaLoadingV2Component,
    LfsaLoadingComponent,
    LfsaOptionsComponent,
    LfsaOptionsExportComponent,
    LfsaGhBarraSimpleComponent,
    LfsaGhColumnSimpleComponent,
    LfsaGhParetoComponent,
    LfsaGhPastelComponent,
    LfsaGhStackbarComponent,
    LfsaComboBoxMultComponent,
    LfsaInputSearchComponent,
    LfsaButtonLoadingComponent,
    ManuV2Component,
    LfsaDtTablaComponent,
    LfsaBotonsGridComponent,
    LfsaAlertsComponent,
    LfsaOptionExportPortalComprasComponent,
    LfsaGhGaugeComponent,
    LfsaGhCampanaGaussComponent,
    NumericAggridComponent,
    LfsaGhDualAxesComponent,
    LfsaComboBoxV3Component,
    FormControlPipe,
    CheckboxRenderer,
    LfsaPageSizeSelectorComponent,
    LfsaSwitchComponent,
    LfsaDivRespuestaSapComponent,
    LfsaSelectOptIspComponent,
    LfsaAccordionIspComponent,
    LfsaSwitchIspComponent,
    LfsaSearchListIspComponent,
    LfsaGhAreaComponent,
    ChatbotWidgetComponent
  ],
  exports: [
    HeaderComponent,
    MenuComponent,
    FooterComponent,
    ChatbotWidgetComponent,
    LfsaInputComponent,
    LfsaErrorMsgComponent,
    LfsaBotonEditarGridComponent,
    LfsaCardComponent,
    LfsaComboBoxComponent,
    LfsaModalComponent,
    LfsaBotonesFormularioComponent,
    LfsaCardV2Component,
    LfsaLoadingV2Component,
    LfsaLoadingComponent,
    LfsaOptionsComponent,
    LfsaOptionsExportComponent,
    LfsaGhBarraSimpleComponent,
    LfsaGhColumnSimpleComponent,
    LfsaGhParetoComponent,
    LfsaGhPastelComponent,
    LfsaGhStackbarComponent,
    LfsaComboBoxMultComponent,
    LfsaInputSearchComponent,
    LfsaButtonLoadingComponent,
    ManuV2Component,
    LfsaDtTablaComponent,
    LfsaBotonsGridComponent,
    LfsaAlertsComponent,
    LfsaOptionExportPortalComprasComponent,
    LfsaGhGaugeComponent,
    LfsaGhCampanaGaussComponent,
    LfsaGhDualAxesComponent,
    NumericAggridComponent,
    LfsaComboBoxV3Component,
    FormControlPipe,
    CheckboxRenderer,
    LfsaPageSizeSelectorComponent,
    LfsaSwitchComponent,
    LfsaDivRespuestaSapComponent,
    LfsaSelectOptIspComponent,
    LfsaAccordionIspComponent,
    LfsaSwitchIspComponent,
    LfsaSearchListIspComponent,
    LfsaGhAreaComponent,
    BusquedaClienteModule
  ],
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        ChartModule,
        AgGridModule.withComponents([LfsaBotonEditarGridComponent]),
        NgMultiSelectDropDownModule.forRoot(),
        TooltipModule,
        NgSelectModule,
        NgxDatatableModule,
        BusquedaClienteModule
      ],
  entryComponents: [
    LfsaModalComponent
  ]
})

export class SharedModule {}
